module.exports = __webpack_public_path__ + "static/media/C2v6.d09fe55f.mp3";